import type { ResumeDto } from "@reactive-resume/dto";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@reactive-resume/ui";
import { useResumeThumbnail } from "@/client/services/resume/preview";

type ResumeDownloadDialogProps = {
  resume?: ResumeDto;
  open: boolean;
  loading: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
};

export const ResumeDownloadDialog = ({
  resume,
  open,
  loading,
  onOpenChange,
  onConfirm,
}: ResumeDownloadDialogProps) => {
  const thumbnail = useResumeThumbnail(
    resume?.id ?? "",
    resume?.updatedAt,
    resume?.data.metadata.template,
  );

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="z-50 sm:max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle>Télécharger votre CV ?</AlertDialogTitle>

          <AlertDialogDescription>
            Le téléchargement de ce CV va consommer un crédit de téléchargement. Voulez-vous
            continuer ?
          </AlertDialogDescription>
        </AlertDialogHeader>

        {resume && (
          <div className="my-4 flex justify-center overflow-hidden rounded-xl border border-slate-200 bg-slate-50">
            <img
              src={thumbnail.src}
              alt={`Aperçu de ${resume.title}`}
              onError={thumbnail.showTemplate}
              className="h-64 w-full object-contain object-top shadow-sm"
            />
          </div>
        )}

        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading}>Annuler</AlertDialogCancel>

          <AlertDialogAction
            disabled={loading}
            onClick={(event) => {
              event.preventDefault();
              onConfirm();
            }}
            className="bg-emerald-600 hover:bg-emerald-700"
          >
            {loading ? "Génération…" : "Confirmer et télécharger"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
